import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

/**
 * Handles the post Google-login redirect which lands at
 *   /dashboard#session_id=xxxx
 * We extract session_id, exchange it with backend, then clean URL.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth, setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const sessionId = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data.user);
        // Clean up hash, then navigate
        window.history.replaceState(null, "", window.location.pathname);
        // If fresh user, send to qualification
        if (data.user.kyc_status === "pending") {
          navigate("/qualification", { state: { user: data.user }, replace: true });
        } else {
          navigate("/dashboard", { state: { user: data.user }, replace: true });
        }
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/login?error=oauth");
      }
    })();
  }, [navigate, setUser, checkAuth]);

  return (
    <div className="min-h-[60vh] grid place-items-center" data-testid="auth-callback-loading">
      <div className="text-sm uppercase tracking-[0.2em] text-slate-500">Connexion…</div>
    </div>
  );
}
